<template lang="pug">
    .events_orbits_wrapper(:class="['orbits_'+orbitsCount, hideOrbits?'hideOrbits':'']")
        .events_orbit(:class="{hide: popup==='mainPopup', orbits_stop: orbits_stop || popup==='mainPopup',}" )
            .ellipse(v-for="(orbit, o_ind) in orbitsCount" :key="key+o_ind")
                .dot(v-for="(event, ind) in getOrbitEvents(o_ind)"
                    data-hover
                    :key="ind"
                    @click="$router.replace('/#history_'+event.id)"
                    @mouseenter="orbitsStop($event.target)"
                    @mouseleave="orbitsGo($event.target)"
                    :style="{animationDelay: -turnOverTime / getOrbitEvents(o_ind).length * ind+ 's'}")
                    .icon()
                        .photo
                            .decor.circle_red
                            span(:style="{backgroundImage: 'url('+event.icon+')'}")
                        .decor.left_line
                        .text
                            i
                            span(v-html="event.preview_text_short")
                        .decor.horline_blue
                        .decor.horline_red
                        .decor.rect_grey



</template>

<script>
    export default {
        name: "EventsOrbits",
        props: ['events', 'hideOrbits'],
        data: () => ({
            //in_one_orbit: 5, // количество событий на орбите
            turnOverTime: 35, // sec
            orbits_stop: false,
            key: Math.random(),
        }),
        watch:{
            events(){
                this.key = Math.random();
            }
        },
        methods: {
            getOrbitEvents(o_ind){
                return this.events.slice(o_ind*this.in_one_orbit,o_ind*this.in_one_orbit + this.in_one_orbit)
            },
            orbitsGo(target){
                let dots = document.querySelectorAll('.events_orbit .dot');
                Array.prototype.forEach.call(dots, (el)=>{
                    el.classList.remove('hover');
                });
                target.closest('.ellipse').style['z-index'] = 65;
                setTimeout(()=>{
                    this.orbits_stop=false
                })
            },
            orbitsStop(target){
                this.orbits_stop=true
                setTimeout(()=>{
                    target.classList.add('hover');
                    target.closest('.ellipse').style['z-index'] = 66;
                })
            },
        },
        computed:{
            popup(){
                return this.$store.state.popup;
            },
            in_one_orbit(){
                return this.events.length<16?5:this.events.length<19?6:7
            },
            orbitsCount(){
                let count = Math.ceil(this.events.length/5);
                if (count > 3) count = 3;
                return count
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";

    .events_orbits_wrapper{
        position: absolute;
        top: 50%;
        left: 50%;
        transition: opacity .5s;
        &.hideOrbits{
            opacity: 0;
        }

        &.orbits_3 .ellipse{
            &:nth-of-type(1){
                transform: rotateZ(-60deg) scale(.195, 1) translate(-50%, -50%);
                .dot .icon{
                    transform: rotate(60deg);
                }
            }
            &:nth-of-type(2){
                transform: rotateZ(60deg) scale(.195, 1) translate(-50%, -50%);
                .dot .icon{
                    transform: rotate(-60deg);
                }
            }
            &:nth-of-type(3){
                transform: rotateZ(90deg) scale(.195, 1) translate(-50%, -50%);
                .dot .icon{
                    transform: rotate(-90deg);
                }
            }
        }
        &.orbits_2 .ellipse{
            &:nth-of-type(1){
                transform: rotateZ(-70deg) scale(.195, 1) translate(-50%, -50%);
                .dot .icon{
                    transform: rotate(70deg);
                }
            }
            &:nth-of-type(2){
                transform: rotateZ(70deg) scale(.195, 1) translate(-50%, -50%);
                .dot .icon{
                    transform: rotate(-70deg);
                }
            }
        }
        &.orbits_1 .ellipse{
            &:nth-of-type(1){
                transform: rotateZ(-80deg) scale(.195, 1) translate(-50%, -50%);
                .dot .icon{
                    transform: rotate(80deg);
                }
            }
        }
    }
    .events_orbit{
        &.hide .ellipse{
            z-index: 0;
            opacity: 0;
            transition: .2s .2s;
            pointer-events: none;
            .dot{
                pointer-events: none;
            }
        }

        &.orbits_stop .ellipse .dot{
            animation-play-state: paused;
        }
    }
    .ellipse {

        z-index: 65;
        display: block;
        position: absolute;
        top: 52%;
        left: 48.5%;
        width: 64vw;
        height: 64vw;
        border-radius: 50%;
        transform-origin: top left;
        transition: all .5s .5s, transform 0s;
        pointer-events: none;

        &:before {
            content: "";
            position: absolute;
            top: 1%;
            right: 0;
            bottom: -1.5%;
            left: 0;
            background: url(../../assets/img/ellips_bg_light.png) no-repeat center center / 100% 100%;
            pointer-events: none;
        }

        .dot {
            position: absolute;
            width: to_rem(50px);
            height: to_rem(50px);
            border-radius: 100%;
            top: 50%;
            left: 50%;
            transform: translateX(-32vw) scale(5, 1);
            cursor: pointer;
            pointer-events: all;
            transform-style: preserve-3d;
            animation: circle 35s linear infinite;
            .icon {
                position: relative;
                min-width: 100%;
                height: 100%;
                transform-style: preserve-3d;
                transform: translate3d(0,0,0);
            }
            .decor{
                position: absolute;
                pointer-events: none;
            }
            .photo{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 100%;
                height: 100%;
                transform: translate(-50%, -50%);
                transition: .2s;
                .circle_red{
                    bottom: -0.3%;
                    left: -0.3%;
                    width: 104%;
                    height: 102%;
                    background: url(../../assets/img/elements/hover/circle_red.png) no-repeat center center / 100% 100%;
                }
                span{
                    position: relative;
                    display: block;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background: no-repeat center center / cover;
                }
            }
            .left_line{
                left: -120%;
                top: -142%;
                width: 6.1rem;
                height: 10.4rem;
                z-index: -2;
                background: url(../../assets/img/elements/hover/left_line.png) no-repeat center center / 100% 100%;
            }
            .text{
                position: absolute;
                left: 36%;
                bottom: 127%;
                width: 13.4rem;
                //padding: 0.7rem 1rem 1.15rem 1.1rem;
                padding: 0.7rem 1.2rem 1.15rem 1.5rem;
                color: #fff;
                pointer-events: none;
                z-index: -2;
                background: url(../../assets/img/elements/hover/rect_blue.png) no-repeat center center / 100% 100%;
                i{
                    float: left;
                    width: 15%;
                    padding-top: 30%;
                    -webkit-shape-outside: polygon(100% 100%, 0% 100%, 0% 0%, 68% 0%, 74% 15%, 70% 50%);
                    shape-outside: polygon(0 0, 100% 0, 0 100%);
                }
                span{
                    display: block;
                    font-size: to_rem(14px);
                    line-height: 1.1;
                    letter-spacing: 0.8px;
                }
            }
            .horline_blue{
                left: -21%;
                top: 8%;
                width: 9.2rem;
                height: 0.62rem;
                z-index: -2;
                background: url(../../assets/img/elements/hover/horline_blue.png) no-repeat center center / 100% 100%;
            }
            .horline_red{
                left: 288%;
                top: 62%;
                width: 3.8rem;
                height: 0.79rem;
                z-index: -2;
                background: url(../../assets/img/elements/hover/horline_red.png) no-repeat center center / 100% 100%;
            }
            .rect_grey{
                left: 184%;
                bottom: -32%;
                width: 9.2rem;
                height: 8.1rem;
                transform-origin: right;
                z-index: -3;
                background: url(../../assets/img/elements/hover/rect_gray.png) no-repeat center center / 100% 100%;
            }

           /* .circle_red, .left_line, .text, .rect_grey, .horline_blue, .horline_red{
                will-change: transform;
            }*/


            .circle_red{
                transform: scale(0.5);
            }
            .left_line{
                transform: scale(0);
            }
            .text{
                transform: rotate(15deg) scale(0.5);
                opacity: 0;
            }
            .rect_grey{
                transform: rotate(-25deg);
                opacity: 0;
            }
            .horline_blue{
                transform: translate3d(-40%, 0, 0) rotate(20deg) scaleX(0.5);
                opacity: 0;
            }
            .horline_red{
                transform: rotate(20deg) scale(0);
                opacity: 0;
            }

            &.hover{
                z-index: 1;
                .circle_red, .left_line, .text, .rect_grey, .horline_blue, .horline_red{
                    transform: translate3d(0px, 0px, 0px);
                    opacity: 1;
                }
                .photo{
                    width: 210%;
                    height: 210%;
                }
                .circle_red{
                    transition: transform .3s;
                }
                .left_line{
                    animation: left_line .7s ;
                }
                .text{
                    transition: transform .7s .3s, opacity .2s .3s;
                }
                .rect_grey{
                    transition: transform .6s .4s, opacity .6s .4s;
                }
                .horline_blue{
                    transition: transform .6s .2s, opacity .6s .2s;
                }
                .horline_red{
                    transition: transform .7s .5s, opacity 0s .5s;
                }
            }
            @keyframes left_line {
                from{transform: scale(0)}
                20%{transform: scale(0.2) rotate(5deg)}
                40%{transform: scale(0.6) rotate(-5deg)}
                60%{transform: scale(1) rotate(5deg)}
                80%{transform: scale(1) rotate(-5deg)}
                100%{transform: scale(1) rotate(0deg)}
            }
        }

        /*&:hover .dot:hover {*/
        /*   animation-play-state: paused;*/
        /*}*/

    }


    @keyframes circle {
        from {
            transform: rotate(0deg) translate3d(-32vw, 0, 0) rotate(0) scale(5, 1);
        }
        to {
            transform: rotate(360deg) translate3d(-32vw, 0, 0) rotate(-360deg) scale(5, 1);
        }
    }
</style>
